
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 23 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.33 11.614V4.939l5.9 3.337-5.9 3.338zM22.481 2.92A2.816 2.816 0 0020.473.953C18.702.488 11.6.488 11.6.488s-7.103 0-8.874.465A2.816 2.816 0 00.72 2.921C.246 4.656.246 8.276.246 8.276s0 3.62.474 5.355a2.816 2.816 0 002.008 1.967c1.771.465 8.874.465 8.874.465s7.102 0 8.873-.465a2.816 2.816 0 002.008-1.967c.475-1.735.475-5.355.475-5.355s0-3.62-.475-5.355z"}})])
          )
        }
      }
    